import { render, staticRenderFns } from "./LaravelTest.vue?vue&type=template&id=6d835e0c&scoped=true"
import script from "./LaravelTest.vue?vue&type=script&lang=js"
export * from "./LaravelTest.vue?vue&type=script&lang=js"
import style0 from "./LaravelTest.vue?vue&type=style&index=0&id=6d835e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d835e0c",
  null
  
)

export default component.exports